import React, { useState, useEffect } from "react";
import "./DisplayCategories.css";
import { useNavigate } from "react-router-dom";
import { Products } from "../Products";
import axiosConfig from "../../Service/axiosConfig";
import { buildSeoPath } from "../../Utils/routes";

const DisplayCategories = ({ Setlogin, LoginAccount, data }) => {
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  return (
    <>
      <div className="">
        {loading ? (
          <div className="loader-container">
            <img src={require("../images/loader.gif")} alt="Loading..." />
          </div>
        ) : (
          <div className="display-categories">
            {data.length >= 1 &&
              data.map((itemObj, index) => {
                return (
                  <React.Fragment key={itemObj.id}>
                    {/* Render the Products component */}
                    <Products
                      products_for={itemObj.name}
                      promo_id={itemObj.promo_id}
                      promo_slug={itemObj.promo_slug}
                      filter_id={itemObj.sub_id}
                      // product_slug={itemObj.sub_slug}
                      product_slug={itemObj.sub_slug || itemObj.cat_slug}
                      Setlogin={Setlogin}
                      LoginAccount={LoginAccount}
                    />

                  </React.Fragment>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};
export { DisplayCategories };
